import '../css/App.css';
import React from "react";
import GalleryLightbox  from "../components/gallery/GalleryLightbox";
import { makeStyles } from "@material-ui/core/styles";
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import {IImage, IPicture} from './MainInterface';
import {
  IPictureProps
} from "../redux/JamHawInterface"

import {
  Typography,
} from "@material-ui/core";
import { Gallery2022 } from './gallery/Gallery2022';
import { Gallery2021 } from './gallery/Gallery2021';
import { Gallery2019 } from './gallery/Gallery2019';
import { Gallery2018 } from './gallery/Gallery2018';
import { Gallery2017 } from './gallery/Gallery2017';
import { Gallery2016 } from './gallery/Gallery2016';
import { Gallery2015 } from './gallery/Gallery2015';
import { Gallery2014 } from './gallery/Gallery2014';
import { Gallery2013 } from './gallery/Gallery2013';
import PictureViewerX from './PictureViewerX';
import type { SlideImage } from "yet-another-react-lightbox";

const useStyles = makeStyles((theme) => ({
  btn: {
    marginTop: "5px",
    marginRight: "5px",
    padding: "2px",
  },
  canvas:{
    width: "100%",
    height: "100%",
  }
}))

const years:string[] = ["2022", "2021","2019","2018","2016","2015","2014","2013"];

var img:IImage[] = []; 
var slides: SlideImage[]; 

const BootstrapButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  padding: '6px 12px',
  border: '1px solid',
  marginRight: '4px',
  marginBottom: '4px',
  lineHeight: 1.5,
  backgroundColor: '#0063cc',
  borderColor: '#0063cc',
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  '&:hover': {
    backgroundColor: '#0069d9',
    borderColor: '#0062cc',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#0062cc',
    borderColor: '#005cbf',
  },
  '&:focus': {
    boxShadow: '0 0 0 0.2rem rgba(255,255,0,.5)',
  },
});

export function Picture(): JSX.Element {
  const classes = useStyles();
  const images:IPicture[] = []; 

  const [selectedYear, SetSelectedYear] = React.useState(years[0]);

  const handleUserChange = (event: any) => {
    //console.log(event.currentTarget.id.split("_")[1]);
    SetSelectedYear(event.currentTarget.id.split("_")[1]);
  };

  if(selectedYear)
  {
    switch(selectedYear){
      case '2022': slides = [ ...Gallery2022() ]; break;
      case '2021': slides = [ ...Gallery2021() ]; break;
      case '2019': slides = [ ...Gallery2019() ]; break;
      case '2018': slides = [ ...Gallery2018() ]; break;
      
      case '2017': slides = [ ...Gallery2017() ]; break;
      case '2016': slides = [ ...Gallery2016() ]; break;
      case '2015': slides = [ ...Gallery2015() ]; break;
      case '2014': slides = [ ...Gallery2014() ]; break;
      case '2013': slides = [ ...Gallery2013() ]; break;
    }
    //console.log(selectedYear, img);
    //SetYearGallery(year);
    //SetGallery(img.images);    
  }
  //console.log(years);
  let ip = {images : img};

    ////////////////////////////////////////////////////
  // PROPS PASSING 
  ////////////////////////////////////////////////////
  const _props:IPictureProps = 
  {
    slides: slides,
  }

  return (
      <div id="picture" className={classes.canvas}>
        <Box sx={{ flexGrow: 1 }}>

            {years.map((item, index) => (
            
              <BootstrapButton 
                variant="contained" 
                color="success"
                className={classes.btn} id={"item_"+item} key={"item_"+index} onClick={handleUserChange}>
                {item}
              </BootstrapButton>


            ))}

            
            <Paper elevation={4}
              style={{
                
                  padding: 0,
                  border: "1px solid black",
                  scrollbarWidth: "none",
                  overflow: 'auto'            
                }}>        
              {/* <PictureViewerX {...ip} />  */}
                <Typography  
                  style={{
                    fontWeight: 800,
                  }}
                  variant="h6">
                  Gallery {selectedYear}
                </Typography>                  
            </Paper>  

            <div style={{backgroundColor: "#000"}}>
            {
              _props.slides !== undefined &&
                <GalleryLightbox {..._props}/>
            }
            </div>
                     
        </Box>
      
      </div>)
}

export default Picture;
